export const LAB_BROKER_TIMEOUTS = {
	IframeReadyMs: 30_000,
	TokenFetchMs: 30_000,
	TokenExpirationBufferMs: 60_000,
	ClosingTimerMs: 10_000
};

export const LAB_BROKER_ERROR_GENERIC = 'Some error with a lab broker';
export const LAB_BROKER_TOKEN_FETCH_ERROR = 'Failed to obtain Custom Rx session token';

export const LAB_BROKER_UNAVAILABLE_DIALOG_FIRST_RETRY_MS = 10_000;
export const LAB_BROKER_UNAVAILABLE_DIALOG_RETRY_INTERVAL_MS = 30_000;
